module.exports = __webpack_public_path__ + "img/returnAdvanceS1Page.af13bf3b.png";